import React from "react";
import { useState } from "react";
import "./../componts/styles.css";

export default function Faq() {
  const [accordion, setAccordion] = useState("");

  return (
    <>
      <section id="courses" className="bg-gray-100 py-12 px-6 lg:px-40">
        <h2 className="secondary-text font-bold text-center text-3xl mb-6">
          Our Courses
        </h2>
        <div className="grid grid-cols-1 gap-8 mt-12">
          <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-2xl transition duration-300 flex flex-col md:flex-row text-sm relative">
            <div className="w-full md:w-1/2 md:mr-6 flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-semibold secondary-text">
                  Frequently Asked Question
                </h3>
                <p className="text-gray-600 mt-2">
                  Curious about our services? <br />
                  <br /> We’ve gathered answers to the top questions we receive
                  to keep you informed and confident in working with us!
                </p>
              </div>
            </div>

            <div className="w-full md:w-1/2 mt-6 md:mt-0">
              <div className="text-xs max-h-80 overflow-y-auto scrollbar-primary rounded-lg">
                <div className="border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("a")}
                  >
                    What services do you offer, and what’s your specialty?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "a" ? "" : "hidden"
                    }`}
                  >
                    <p className="space-y-3">
                      We offer a wide range of essential services, including
                      online applications, printing, graphic design, website
                      development, and crypto training. Our specialty lies in
                      delivering fast, reliable, and high-quality solutions
                      tailored to each client’s needs. Whether you need a
                      striking logo, a fully responsive website, or support with
                      online service applications, we’re here as your trusted
                      partner for all your digital needs.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("b")}
                  >
                    How does the pricing work, and what’s included in each
                    package?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "b" ? "" : "hidden"
                    }`}
                  >
                    <p className="text-gray-600">
                      Our pricing is designed to be affordable and transparent,
                      with different packages based on project scope and
                      complexity. Each package includes a consultation, project
                      planning, and a set number of revisions, so there are no
                      surprises. We’re happy to discuss customized options to
                      fit any budget and ensure you get the best value for your
                      investment.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("d")}
                  >
                    What’s your typical timeline for completing a project?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "d" ? "" : "hidden"
                    }`}
                  >
                    <p className="space-y-3">
                      Efficiency is our priority. For website development, we
                      can deliver a fully functional site in as little as two
                      days, depending on the project’s complexity. Graphic
                      design projects, like logos or branding kits, typically
                      take between 1-3 days. We’re flexible with deadlines and
                      always open to negotiating timelines to accommodate urgent
                      needs. Quick, quality work is our promise.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("e")}
                  >
                    Can you provide examples or a portfolio of previous work?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "e" ? "" : "hidden"
                    }`}
                  >
                    <p className="text-gray-600">
                      Absolutely! We have a comprehensive portfolio showcasing
                      our work in graphic design, web development, and other
                      essential services. We believe our work speaks for itself
                      and are happy to share examples that align with your
                      vision. You’ll find that our portfolio reflects the
                      quality and creativity we bring to every project.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("f")}
                  >
                    How does the process work from start to finish?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "f" ? "" : "hidden"
                    }`}
                  >
                    <p className="text-gray-600">
                      Our process is streamlined and client-focused. Once you
                      place an order, we initiate a consultation to understand
                      your vision. From there, we provide a project outline and
                      timeline, and then proceed with design or development. We
                      keep you updated at every step, and revisions are handled
                      smoothly to ensure complete satisfaction. We collaborate
                      closely with clients to deliver exactly what they
                      envision.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("g")}
                  >
                    Do you offer revisions, and are they included in the price?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "g" ? "" : "hidden"
                    }`}
                  >
                    Yes, we include revisions in all our packages because client
                    satisfaction is key. Typically, each package includes a set
                    number of revisions, but we’re always open to negotiation
                    based on your needs. Our goal is to ensure the final product
                    aligns perfectly with your vision.
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("z")}
                  >
                    What tools or platforms do you use?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "z" ? "" : "hidden"
                    }`}
                  >
                    <p className="space-y-3">
                      We work with industry-standard tools to deliver
                      top-quality results. For graphic design, we use Adobe
                      Creative Suite (Photoshop, Illustrator), while for web
                      development, we specialize in using frameworks like
                      WordPress, React, and custom HTML/CSS for flexibility. We
                      tailor our tech stack to the project’s needs to ensure
                      efficient, top-quality outcomes.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("h")}
                  >
                    What’s your communication process, and how often can I
                    expect updates?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "h" ? "" : "hidden"
                    }`}
                  >
                    <p className="space-y-3">
                      Communication is essential to our process. We provide
                      regular updates throughout the project, ensuring
                      transparency and responsiveness. Typically, clients
                      receive daily updates on project status, and we’re
                      available for check-ins via email or phone. We prioritize
                      open communication and negotiation at every step.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("i")}
                  >
                    Do you have experience in my specific industry or type of
                    business?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "i" ? "" : "hidden"
                    }`}
                  >
                    <p className="space-y-3">
                      Our team has worked with clients across various
                      industries, from retail and finance to education and tech.
                      This broad experience allows us to understand unique needs
                      and deliver custom solutions. We’re committed to getting
                      to know each client’s industry specifics and will research
                      as needed to ensure your project is exactly right.
                    </p>
                  </div>
                </div>

                <div className="border-t border-gray-300">
                  <button
                    className="accordion-header w-full text-left py-3 font-semibold text-primary-text text-base"
                    onClick={() => setAccordion("j")}
                  >
                    Are there additional fees for faster delivery or extra
                    services?
                  </button>
                  <div
                    id="course-ecd-objectives"
                    className={`accordion-content p-4 bg-gray-100 ${
                      accordion === "j" ? "" : "hidden"
                    }`}
                  >
                    <p className="space-y-3">
                      For clients who need expedited services, we offer a
                      priority delivery option at a reasonable additional cost.
                      However, we’re always willing to negotiate depending on
                      the scope and urgency of your project. We aim to be
                      flexible and affordable in all we do.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
